"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHtml = exports.isNotThemeStore = exports.isNotIframe = exports.$elParent = exports.$list = exports.$el = exports.transitionToPromise = exports.whenDefined = exports.registerComponent = exports.upperCamelCaseToSnakeCase = exports.createPrefetchLink = exports.isCurrentPageLink = exports.isExternalLink = exports.createPortal = exports.isSafari = exports.removeCustomElementFromBody = exports.appendElementToBody = exports.getTargets = exports.getFocusTargets = exports.viewportObserver = exports.delay = exports.capitalize = void 0;
const transition_util_1 = require("./transition-util");
const capitalize = (word) => {
    const firstSymbol = word.slice(0, 1);
    const restWordPart = word.slice(1);
    return firstSymbol.toUpperCase() + restWordPart;
};
exports.capitalize = capitalize;
const delay = (delay = 0) => {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, delay);
    });
};
exports.delay = delay;
exports.viewportObserver = new IntersectionObserver((entries, _) => {
    entries.forEach(entry => {
        const isInViewport = entry.isIntersecting;
        const isParentHidden = entry.target.closest('[aria-hidden="true"], .hidden');
        entry.target.classList.toggle('is-in-viewport', isInViewport && !isParentHidden);
    });
});
const getFocusTargets = () => {
    const targets = [
        'button:enabled',
        'input:not([type=hidden]):enabled',
        'textarea:enabled',
        'a[href]',
        '[data-focus-trap-target]',
        '[tabindex]:not([tabindex^="-"])',
    ];
    return targets
        .map(target => `${target}:not([data-color-swatches-hidden-count]:empty):not(.hidden)`)
        .join(',');
};
exports.getFocusTargets = getFocusTargets;
const getTargets = element => {
    const targets = (0, exports.$list)((0, exports.getFocusTargets)(), element).filter(target => target.clientWidth > 0);
    const firstTarget = targets[0];
    const lastTarget = targets[targets.length - 1];
    return { targets, firstTarget, lastTarget };
};
exports.getTargets = getTargets;
const appendElementToBody = customElement => {
    const customElementContainer = document.createElement('div');
    customElementContainer.classList.add('hidden');
    document.body.appendChild(customElementContainer);
    customElementContainer.appendChild(customElement);
    return customElementContainer;
};
exports.appendElementToBody = appendElementToBody;
const removeCustomElementFromBody = customElementContainer => {
    customElementContainer.remove();
};
exports.removeCustomElementFromBody = removeCustomElementFromBody;
const isSafari = () => {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
};
exports.isSafari = isSafari;
const createPortal = (children, parent) => {
    let element = (0, exports.$el)('#Portal');
    element.appendChild(children);
    const target = parent && parent.appendChild ? parent : document.body;
    target.appendChild(element);
};
exports.createPortal = createPortal;
const isExternalLink = (href) => {
    return !href.match(/^\//) && !href.includes(window.location.host);
};
exports.isExternalLink = isExternalLink;
const isCurrentPageLink = (href) => {
    return href === window.location.href;
};
exports.isCurrentPageLink = isCurrentPageLink;
const createPrefetchLink = (href) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'prefetch');
    link.setAttribute('href', href);
    document.head.appendChild(link);
};
exports.createPrefetchLink = createPrefetchLink;
const upperCamelCaseToSnakeCase = (value) => {
    return value
        .replace(/^([A-Z])/, $1 => $1.toLowerCase())
        .replace(/([A-Z])/g, $1 => '-' + $1.toLowerCase());
};
exports.upperCamelCaseToSnakeCase = upperCamelCaseToSnakeCase;
const registerComponent = (componentClass) => {
    try {
        const name = (0, exports.upperCamelCaseToSnakeCase)(componentClass.name);
        customElements.define(name, componentClass);
    }
    catch (error) {
        console.log(`component has not been defined`);
    }
};
exports.registerComponent = registerComponent;
const whenDefined = (componentTag) => {
    return customElements.whenDefined(componentTag);
};
exports.whenDefined = whenDefined;
const transitionToPromise = el => {
    return new Promise(resolve => {
        (0, transition_util_1.whenTransitionEnds)(el, () => {
            resolve(null);
        });
    });
};
exports.transitionToPromise = transitionToPromise;
const $el = (selector, scope = document) => {
    return scope.querySelector(selector);
};
exports.$el = $el;
const $list = (selector, scope = document) => {
    return [...scope.querySelectorAll(selector)];
};
exports.$list = $list;
const $elParent = (selector, scope = document) => {
    return scope.closest(selector);
};
exports.$elParent = $elParent;
const isNotIframe = () => {
    return window.self === window.top;
};
exports.isNotIframe = isNotIframe;
const isNotThemeStore = () => {
    return window.self === window.top || Shopify.designMode;
};
exports.isNotThemeStore = isNotThemeStore;
const stripHtml = html => {
    let tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};
exports.stripHtml = stripHtml;
